module.exports = __webpack_public_path__ + "img/0-1.2fb09c99.gif";